<template>
	<div class="slider__container">
		<div class="visual"> <img :src="visual"></div>
		<div :id="addIdentifier" class="slider"/> 

	</div>
</template>


<script>
	export default {

		props: ['sliderValue', 'maxValue', 'stepSize', 'identifier', 'visual'],
		mounted: function() {
			var self = this;

			//TODO calculate radius for smaller devices

			$('.slider').roundSlider({
				radius: 100,
				width: 10,
				max: this.maxValue,
        		step: this.stepSize,
				circleShape: "pie",
				sliderType: "min-range",
				showTooltip: false,
				value: 0,
				startAngle: 316,
				handleShape: "round",
				handleSize: "+15",
				drag: function(data) {
					self.$emit('round-slide', data);
				},
				change: function(data) {
					self.$emit('round-slide', data);
				}
			});
		},

		watch:{
			sliderValue: function (val)
			{
				this.setValue(val);
			},

			maxValue: function (val)
			{
				this.setMaxValue(val);
			}
		},

		beforeDestroy: function() {
			$('.slider').roundSlider('hide').roundSlider('destroy');
		},
		methods: {
			setValue: function(value) {
				$('.slider').roundSlider("option", "value", value);

			},

			setMaxValue: function(value) {
				$('.slider').roundSlider("option", "max", value);

			}
		},
		computed: {
			addIdentifier: function() {
				return 'slider_' + this.identifier;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/minigames/impactcalculator/RoundSlider.vue